// @ts-check

import { cartFetchAndRender } from '@theme/lib-cart';
import { Wishlist } from '@theme/lib-wishlist';

/** @type {WeakSet<HTMLFormElement>} */
var inFlightForms = new WeakSet();

/**
 * @returns {Set<number>}
 */
function getBusyLinesStore() {
  var windowWithStore =
    /** @type {Window & { __sideCartBusyLines?: Set<number> }} */ (window);
  if (!windowWithStore.__sideCartBusyLines) {
    windowWithStore.__sideCartBusyLines = new Set();
  }
  return windowWithStore.__sideCartBusyLines;
}

/**
 * @param {number} line
 */
function isLineBusy(line) {
  return getBusyLinesStore().has(line);
}

/**
 * @param {number} line
 * @param {boolean} isBusy
 */
function setLineBusyState(line, isBusy) {
  var lineItems = document.querySelectorAll(
    '.side-cart__item[data-line="' + line + '"]'
  );
  if (!lineItems.length) return;

  lineItems.forEach(function (lineItem) {
    if (!(lineItem instanceof HTMLElement)) return;

    lineItem.classList.toggle('is-loading', isBusy);
    if (isBusy) {
      lineItem.setAttribute('aria-busy', 'true');
    } else {
      lineItem.removeAttribute('aria-busy');
    }

    var controls = lineItem.querySelectorAll(
      '.quantity-controls-form button[type="submit"], .delete-button-form .delete-button, .move-to-wishlist-form .move-to-wishlist-button'
    );
    controls.forEach(function (control) {
      if (!(control instanceof HTMLButtonElement)) return;

      if (isBusy) {
        control.dataset.wasDisabled = control.disabled ? 'true' : 'false';
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        return;
      }

      if (control.dataset.wasDisabled === 'true') {
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
      } else {
        control.disabled = false;
        control.removeAttribute('aria-disabled');
      }
      delete control.dataset.wasDisabled;
    });
  });
}

/**
 * @param {HTMLFormElement} form
 * @returns {string}
 */
function getInputValue(form, name) {
  var input = form.querySelector('input[name="' + name + '"]');
  if (!(input instanceof HTMLInputElement)) return '';
  return input.value;
}

/**
 * @param {HTMLFormElement} form
 * @returns {{title?: string, image?: string, price?: string, url?: string}}
 */
function getProductData(form) {
  return {
    title: getInputValue(form, 'product_title'),
    image: getInputValue(form, 'product_image'),
    price: getInputValue(form, 'product_price'),
    url: getInputValue(form, 'product_url'),
  };
}

/**
 * @param {HTMLFormElement} form
 */
async function submitMoveToWishlistForm(form) {
  if (inFlightForms.has(form)) return;

  var line = parseInt(getInputValue(form, 'line'), 10);
  var quantity = parseInt(getInputValue(form, 'quantity'), 10);
  var productId = getInputValue(form, 'product_id');

  if (Number.isNaN(line) || Number.isNaN(quantity) || !productId) return;
  if (isLineBusy(line)) return;

  var busyLines = getBusyLinesStore();
  busyLines.add(line);
  setLineBusyState(line, true);

  inFlightForms.add(form);

  try {
    Wishlist.add(productId, getProductData(form));
    await cartFetchAndRender('cart/change.js', {
      line: line,
      quantity: quantity,
    });
  } catch (error) {
    console.error('Move to wishlist failed:', error);
  } finally {
    busyLines.delete(line);
    setLineBusyState(line, false);
    inFlightForms.delete(form);
  }
}

document.addEventListener(
  'click',
  function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest(
      '.move-to-wishlist-form .move-to-wishlist-button'
    );
    if (!(button instanceof HTMLButtonElement)) return;

    var form = button.form;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('move-to-wishlist-form')) return;

    event.preventDefault();
    submitMoveToWishlistForm(form);
  },
  true
);

document.addEventListener(
  'submit',
  function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('move-to-wishlist-form')) return;

    event.preventDefault();
    submitMoveToWishlistForm(form);
  },
  true
);
